import http from 'constants/config';

export const getAdminsService = _ => http.get(`v2/admin/list-admins`);

export const modifyTrialService = (aid, trial_weeks)=> http.put(`v2/admin/${ aid }/trial`, {
    trial_weeks
});
